/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Toast_Autosync_UpdatedInputs */

const es_settings_files_toast_autosync_updated = /** @type {(inputs: Settings_Files_Toast_Autosync_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización automática actualizada.`)
};

const en_settings_files_toast_autosync_updated = /** @type {(inputs: Settings_Files_Toast_Autosync_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-sync updated.`)
};

/**
* | output |
* | --- |
* | "Auto-sync updated." |
*
* @param {Settings_Files_Toast_Autosync_UpdatedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_toast_autosync_updated = /** @type {((inputs?: Settings_Files_Toast_Autosync_UpdatedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Toast_Autosync_UpdatedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_toast_autosync_updated(inputs)
	return en_settings_files_toast_autosync_updated(inputs)
});
export { settings_files_toast_autosync_updated as "settings.files.toast.autosync_updated" }